import React, { useState } from "react";
import PropTypes from "prop-types";
import { markdown } from "markdown";
import Menu from "antd/lib/menu";
import HtmlContent from "@redash/viz/lib/components/HtmlContent";
import TextboxDialog from "@/components/dashboards/TextboxDialog";
import Widget from "./Widget";

function TextboxWidget(props) {
  const { widget, canEdit } = props;
  const [text, setText] = useState(widget.text);
  const [allowIframeHtmlInput, setAllowIframeHtmlInput] = useState(Boolean(widget.options.allowIframeHtmlInput));
  const iframeMessageTarget = `redash:textbox:widget:${widget.id}`;

  const editTextBox = () => {
    TextboxDialog.showModal({
      text: widget.text,
      allowIframeHtmlInput,
    }).onClose(result => {
      const newText = typeof result === "string" ? result : result?.text || "";
      const newAllowIframeHtmlInput = typeof result === "string" ? false : Boolean(result?.allowIframeHtmlInput);

      widget.text = newText;
      widget.options.allowIframeHtmlInput = newAllowIframeHtmlInput;
      setText(newText);
      setAllowIframeHtmlInput(newAllowIframeHtmlInput);
      return widget.save();
    });
  };

  const TextboxMenuOptions = [
    <Menu.Item key="edit" onClick={editTextBox}>
      Edit
    </Menu.Item>,
  ];

  if (!widget.width) {
    return null;
  }

  return (
    <Widget {...props} menuOptions={canEdit ? TextboxMenuOptions : null} className="widget-text">
      <HtmlContent
        className="body-row-auto scrollbox t-body p-15 markdown"
        allowIframeHtmlInput={allowIframeHtmlInput}
        iframeMessageTarget={iframeMessageTarget}>
        {markdown.toHTML(text || "")}
      </HtmlContent>
    </Widget>
  );
}

TextboxWidget.propTypes = {
  widget: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  canEdit: PropTypes.bool,
};

TextboxWidget.defaultProps = {
  canEdit: false,
};

export default TextboxWidget;
